import Script from 'next/script';

import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
  Label,
  SupportCenter,
} from '@shared/ui';

import { supportWidgetData, supportWidgetLanguage, useSupportWidget } from '../model';

import { Feedback } from './Feedback';
import { CreateTicket } from './Ticket';

export const SupportAction = () => {
  const {
    widgetSrc,
    isDrawerOpen,
    setIsDrawerOpen,
    openTicketDrawer,
    openPhoneCall,
    isTicketDrawerIsOpen,
    setTicketDrawerIsOpen,
    openOnlineChat,
    goToSupportCenter,
    isFeedbackDrawerIsOpen,
    openFeedBackDrawer,
    setFeedbackDrawerIsOpen,
  } = useSupportWidget();
  const handlers = {
    openPhoneCall,
    openOnlineChat,
    goToSupportCenter,
    openTicketDrawer,
    openFeedBackDrawer,
  };
  return (
    <>
      {widgetSrc && <Script src={widgetSrc} strategy='lazyOnload' />}

      <Drawer open={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
        <DrawerTrigger asChild>
          <Button
            id='Support_Icon'
            variant='icon'
            className='bg-transparent !text-text active:bg-background rounded-md h-[34px] p-[5px] shadow-none'
          >
            <SupportCenter className='text-text !pointer-events-none scale-[0.68]' />
          </Button>
        </DrawerTrigger>

        <DrawerContent className='w-full gap-y-2'>
          <DrawerHeader>
            <DrawerTitle className='h5-bold leading-[24px]'>
              {supportWidgetLanguage.support}
            </DrawerTitle>
          </DrawerHeader>

          <div className='w-full flex flex-col gap-y-2'>
            {supportWidgetData.map(({ id, label, icon: Icon, iconProps, onClickKey }) => (
              <button
                key={id}
                id={id}
                onClick={handlers[onClickKey as keyof typeof handlers]}
                className='first:!mt-3 w-full h-[64px] rounded-full flex items-center justify-start
                     text-text bg-hover gap-4 px-5 cursor-pointer'
              >
                <Icon className='text-pics pointer-events-none' variant='Bold' {...iconProps} />
                <Label className='body-14-bold leading-[150%] mx-auto'>{label}</Label>
              </button>
            ))}
          </div>
        </DrawerContent>
        <CreateTicket isOpen={isTicketDrawerIsOpen} setIsOpen={setTicketDrawerIsOpen} />
        <Feedback
          setIsWidgetOpen={setIsDrawerOpen}
          isOpen={isFeedbackDrawerIsOpen}
          setIsOpen={setFeedbackDrawerIsOpen}
        />
      </Drawer>
    </>
  );
};
